import React, { useEffect, useState } from 'react'
import { InfoModal } from 'components'
import { useTranslation } from 'react-i18next'
import { useModal } from 'hooks/useModal'
import { PrivacyStatementModal } from '../Footer/PrivacyStatementModal'
import classes from './CookieDisclaimer.module.scss'
import bookingEN from '../../locals/booking_EN.json'

interface CookieModalProps {
  intraModal?: boolean
  label?: string
}

export const CookieModal: React.FunctionComponent<CookieModalProps> = ({
  intraModal = false,
  label = 'cookieDisclaimer.notice',
}) => {
  const [showModal, openModal, closeModal] = useModal()
  const [showLanguagePicker, setShowLanguagePicker] = useState<boolean>()
  const { t } = useTranslation()

  useEffect(() => {
    if ('cookieModal' in bookingEN.cookieDisclaimer) {
      setShowLanguagePicker(true)
    } else {
      setShowLanguagePicker(false)
    }
  }, [])

  return (
    <>
      <p style={{ display: 'inline' }}>
        <u className={classes.notice_link} onClick={openModal}>
          {t(label)}
        </u>
      </p>
      {showModal && (
        <InfoModal
          onClose={closeModal}
          headline={t('cookieDisclaimer.cookieModal.headline')}
          showLanguagePicker={showLanguagePicker}
        >
          <p>{t('cookieDisclaimer.cookieModal.notice')}</p>

          <p>{t('cookieDisclaimer.cookieModal.info')}</p>

          <ol>
            <li className={classes.listItem}>
              {t('cookieDisclaimer.cookieModal.points.1.point')}
              <ol>
                <li className={classes.listItem_inner}>
                  {t('cookieDisclaimer.cookieModal.points.1.a')}
                </li>
                <li className={classes.listItem_inner}>
                  {t('cookieDisclaimer.cookieModal.points.1.b.content')}
                  <ol>
                    <li className={classes.listItem_inner_inner}>
                      {t('cookieDisclaimer.cookieModal.points.1.b.point1')}
                    </li>
                    <li className={classes.listItem_inner_inner}>
                      {t('cookieDisclaimer.cookieModal.points.1.b.point2')}
                    </li>
                    <li className={classes.listItem_inner_inner}>
                      {t('cookieDisclaimer.cookieModal.points.1.b.point3.0')}
                      <a
                        href="http://www.macromedia.com/support/documentation/de/flashplayer/help/settings_manager02.html "
                        target="_blank"
                        rel="noreferrer"
                        className={classes.notice_link}
                      >
                        {t('cookieDisclaimer.cookieModal.points.1.b.point3.1')}
                      </a>
                    </li>
                    <li className={classes.listItem_inner_inner}>
                      {t('cookieDisclaimer.cookieModal.points.1.b.point4')}
                    </li>
                  </ol>
                </li>
                <li className={classes.listItem_inner}>
                  {t('cookieDisclaimer.cookieModal.points.1.c')}
                </li>
              </ol>
            </li>
            <li className={classes.listItem}>
              {t('cookieDisclaimer.cookieModal.points.2.point')}
              <table>
                <thead>
                  <tr>
                    <th>
                      {t('cookieDisclaimer.cookieModal.points.2.listRow.name')}
                    </th>
                    <th>
                      {t(
                        'cookieDisclaimer.cookieModal.points.2.listRow.description'
                      )}
                    </th>
                    <th>
                      {t(
                        'cookieDisclaimer.cookieModal.points.2.listRow.saveTime'
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {t('cookieDisclaimer.cookieModal.points.2.list1.name')}
                    </td>
                    <td>
                      {t(
                        'cookieDisclaimer.cookieModal.points.2.list1.description'
                      )}
                    </td>
                    <td>
                      {t(
                        'cookieDisclaimer.cookieModal.points.2.list1.saveTime'
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {t('cookieDisclaimer.cookieModal.points.2.list2.name')}
                    </td>
                    <td>
                      {t(
                        'cookieDisclaimer.cookieModal.points.2.list2.description'
                      )}
                    </td>
                    <td>
                      {t(
                        'cookieDisclaimer.cookieModal.points.2.list2.saveTime'
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li className={classes.listItem}>
              {t('cookieDisclaimer.cookieModal.points.3.point')}
              <p>{t('cookieDisclaimer.cookieModal.points.3.content')}</p>
              <p>
                <PrivacyStatementModal
                  intraModal={true}
                  label="components.footer.privacyStatementModal.heading"
                />
              </p>
            </li>
          </ol>
        </InfoModal>
      )}
    </>
  )
}
